import fetch from 'auth/FetchInterceptor'

class AbstractService {

  static #baseUrl = '/rest/v1/dealer/data';

  static _getUrl() {
    return `${AbstractService.#baseUrl}`;
  }


  static async _getResource(url, params) {

    const resp = await fetch({
      url,
      method: 'get',
      params: params,
    });

    return resp.data;
  }


  static async _setResource(url, { method = 'post', data, headers = {} }) {

    const resp = await fetch({
      url,
      method: method,
      data,
      headers
    });

    return resp.data;
  }


  static async _optResource(url) {

    const resp = await fetch({
      url,
      method: 'options'
    });

    return resp.data;
  }


  static async _downloadZip(url) {

    return fetch({
      url,
      method: 'get',
      responseType: 'blob',
      headers: {
        'Content-Type': `application/zip`,
      },
    });

  }


  static async _downloadXls(url, {data}) {

    return fetch({
      url,
      method: 'post',
      data: data,
      responseType: 'blob',
      /*
      headers: {
          'Content-Type': `application/xlsx`,
      },
      */
    });

  }

  static async _downloadXlsGet(url, {data}) {

    return fetch({
      url,
      method: 'get',
      data: data,
      responseType: 'blob',
      /*
      headers: {
          'Content-Type': `application/xlsx`,
      },
      */
    });

  }

  static async _download(url) {

    return fetch({
      url,
      method: 'get',
      responseType: 'blob',
    });

  }


  static _getPageSizeUrlParamList(params = {}) {

    const {
      pageId = 1,
      pageSize = 50,
      filters = {},
      search = ''
    } = params;

    let urlParam = '';
    let paramItem = ''
    if (Number.isInteger(pageId)) {
      paramItem = !urlParam ? '?' : '&';
      paramItem += `page=${pageId}`;
      urlParam += paramItem;
    }

    if (Number.isInteger(pageSize)) {
      paramItem = !urlParam ? '?' : '&';
      paramItem += `page_size=${pageSize}`;
      urlParam += paramItem;
    }

    if (search) {
      paramItem = !urlParam ? '?' : '&';
      paramItem += `search=${search}`;
      urlParam += paramItem;
    }

    if (typeof filters === 'object') {
      for (let i in filters) {

        if (!filters.hasOwnProperty(i)) {
          continue;
        }

        if (!Array.isArray(filters[i])) {

          paramItem = !urlParam ? '?' : '&';
          paramItem += `${i}=${filters[i]}`;
          urlParam += paramItem;
          continue;
        }

        for (const itemFilter of filters[i]) {
          paramItem = !urlParam ? '?' : '&';
          paramItem += `${i}=${itemFilter}`;
          urlParam += paramItem;

        }
      }
    }

    return {
      pageSize,
      urlParam
    };

  }


}

export default AbstractService;